import Nullstack from 'nullstack';
export default function IconSquareToggleHorizontal({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-square-toggle-horizontal",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-20"
  }), "   ", Nullstack.element("path", {
    d: "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
  }), "   ", Nullstack.element("path", {
    d: "M18 20a2 2 0 0 0 2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M4 18a2 2 0 0 0 2 2"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "20",
    x2: "10",
    y2: "20"
  }), " ");
}